export const MAX_INLINE_SIZE = '55ch';
export const ILLUSTRATION_SIZE = '120px';